import { motion } from "motion/react";
import { useEffect } from "react";
import usePreloadImage from "../hooks/use-preload-image";

export default function Loading({
  index,
  onNext,
}: {
  index: number;
  onNext: () => void;
}) {
  usePreloadImage("/wordmark-mini.png");

  const messages = [
    "we found love in a hopeless\nplace… IG DMs",
    "now entering the friend zone…",
    "third time’s the charm…?",
  ];

  const message = messages[index];

  const LOCAL_STORAGE_KEY = `ig-valentine-skip-loading-${index}`;

  useEffect(() => {
    if (localStorage.getItem(LOCAL_STORAGE_KEY)) {
      onNext();
      return;
    }

    setTimeout(
      () => {
        onNext();
        localStorage.setItem(LOCAL_STORAGE_KEY, "true");
      },
      import.meta.env.DEV ? 500 : 3_000
    );
  }, []);

  return (
    <div className="h-full flex flex-col items-center justify-center">
      {/* TODO: the animation should be light within the logo */}
      <motion.img
        src="/logo-with-shadow.png"
        alt="logo"
        className="w-20"
        animate={{ rotate: [-5, 5, -5] }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      <p className="mt-4 text-brand-dark-pink text-xl font-bold px-16 mx-auto text-center whitespace-pre-line">
        {message}
      </p>
    </div>
  );
}
